module.exports = __webpack_public_path__ + "79b41af92bfbc2a45c8aed6b9b3dc78c.svg";